import React, { useLayoutEffect, useState } from 'react';
import { ConfigProvider, theme as antTheme } from 'antd';

import { Theme } from '../../types';
import { ThemeScopeProps } from './types';

// Puts what is inside in the theme: antd's components through a config of their own, and
// everything else through the variables the theme's stylesheet sets under [data-theme]
// (framework/styling/themes). The wrapper takes no box of its own, so the layout inside is as if
// it wasn't there.
export function ThemeScope({ theme, children }: ThemeScopeProps) {
	// antd puts its variables on this class, and gives it to every component of the scope
	const cssVarKey = `css-var-theme-${theme}`;

	// popups and modals are rendered at the end of the body, out of the wrapper: they go into a
	// layer of their own there, in the same theme
	const [popupLayer] = useState(() => document.createElement('div'));

	useLayoutEffect(() => {
		document.body.appendChild(popupLayer);
		return () => popupLayer.remove();
	}, [popupLayer]);

	useLayoutEffect(() => {
		popupLayer.className = cssVarKey;
		popupLayer.dataset.theme = theme;
	}, [popupLayer, cssVarKey, theme]);

	return (
		<ConfigProvider
			getPopupContainer={() => popupLayer}
			theme={{
				algorithm: theme == Theme.Dark ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
				cssVar: { key: cssVarKey },
				hashed: false,
			}}
		>
			<div className={cssVarKey} data-theme={theme} style={{ display: 'contents' }}>
				{children}
			</div>
		</ConfigProvider>
	);
}
